<template>
      <div class="header">
        <router-link to="/">{{ goal }}</router-link>
      </div>
</template>

<script>
export default {
  name: 'header',
  props: ["goal"]
}
</script>



// WEBPACK FOOTER //
// src/components/CardHeader.vue